import * as React from 'react';
import { map, sortBy } from 'lodash';
import { useQuery } from '@apollo/client';
import { PanelRow, Button } from '@teamsnap/teamsnap-ui';

import SeasonCard from '../../components/season/season-card';
import * as GqlSeasons from '../../core/gql/queries/seasons';
import Program from '../../models/program';
import { ActivitySeasonType } from '../../models/season';
import { AuthContext } from 'auth/dist/contexts';
import { hasPermissionForOrg, Permission } from 'core/permissions';

export interface Props {
  selectSeasonIdCallback: (type: ActivitySeasonType, id?: number) => void;
  program: Program;
  showArchived?: boolean;
}

export type RefProps = { refetchSeasons: () => Promise<any> };

const SeasonList = React.forwardRef(
  ({ selectSeasonIdCallback, program, showArchived }: Props, ref: React.ForwardedRef<RefProps>) => {
    const context = React.useContext(AuthContext);
    const canUserDeleteSeason = hasPermissionForOrg(context.user, Permission.SeasonDelete, program.organizationId);

    const querySeasons = useQuery(GqlSeasons.QUERY, {
      variables: {
        programId: program.id,
        isArchived: showArchived ? null : false,
      },
    });

    React.useImperativeHandle(ref, () => ({ refetchSeasons: querySeasons.refetch }), [querySeasons.refetch]);

    if (querySeasons.loading)
      return (
        <PanelRow mods="u-textCenter">
          <div className="Loader-indicator">
            <span className="SpinAnimation" />
            <div className="Loader-indicatorText" data-testid="lodingSeasonsMessage">
              Loading seasons...
            </div>
          </div>
        </PanelRow>
      );

    if (querySeasons.error) return <div>{querySeasons.error}</div>;

    if (querySeasons.data.seasons.length > 0) {
      return (
        <>
          {' '}
          {map(sortBy(querySeasons.data.seasons, ['name']), (season) => (
            <SeasonCard
              key={season.id}
              season={season}
              programName={program.name}
              selectSeasonIdCallback={selectSeasonIdCallback}
              canUserDeleteSeason={canUserDeleteSeason}
              showArchived={showArchived}
            />
          ))}
        </>
      );
    } else {
      return (
        <PanelRow mods="u-textCenter">
          <h4 data-testid="noSeasonsHeader">
            No seasons for this program currently exist.&nbsp;&nbsp;
            {/* <Button color="primary" icon="plus" iconPosition="left" onClick={() => selectSeasonIdCallback(ActivitySeasonType.LegacyOrgSeason, null)}>
            Create Legacy Season
          </Button>
          &nbsp;&nbsp; */}
            <Button
              color="primary"
              icon="plus"
              iconPosition="left"
              onClick={() => selectSeasonIdCallback(ActivitySeasonType.ClubSeason, null)}
              testId="createSeasonButton"
            >
              Create Season
            </Button>
          </h4>
        </PanelRow>
      );
    }
  }
);

SeasonList.defaultProps = {
  showArchived: null,
};

export default SeasonList;
